import axios from "axios";
import store from "@/store";
import router from "@/router";
import {toast} from '../class/Notification'

export var loan_status = [
    '',
    'در حال پردازش',
    'تایید شده',
    '',
    'تحویل داده شده',
    '',
    'لغو شده',
]

// generate random hash for product
export var generateHash = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

export const findHashProductOnLocalStorage = (product) => {
    let products = JSON.parse(localStorage.getItem('products'));
    for (let i in products) {
        let item = products[i];
        if (item.variation == 1 && item.id == product.id && item.sub_product_id == product.sub_product_id || item.variation == 0 && item.id == product.id) {
            return item.productHash;
        }
    }
}

const queryBuilder = (filters) => {
    /* get items from  Filters component data state and create a query string for filters data
        supported filters:
        - brands
        - category
        - status
        - is_digital
        - price

         object shape should like this you can set arbitrary items in the object:
         filters: {
            price:{
                minValue: 0,
                maxValue: 1000000000,
            },
            category: [],
            brand: [],
            is_digital: 0
        },

    */
    let query = ''
    const keys = Object.keys(filters);
    for (let i in keys) {
        const key = keys[i]
        const value = filters[key];
        if (key == 'price' && (value.minValue != null && value.maxValue != null)) {
            query += `${key}=${value.minValue}-${value.maxValue}&`
        }
        if (key == 'search' || key == "is_digital" || key == "status" || key == 'sort' || key == 'per_page' || key == 'quantity') {
            query += `${key}=${value}&`
        }
        if (value.length > 0 && typeof value != 'string') { // check selected key have value
            const valueToString = value.join(',')
            query += `${key}=${valueToString}&`
        }
    }
    return query
}


const reshapeLoanForm = (form) => {
    let formData = new FormData();

    for (let [index, value] of Object.entries(form.loan_assets)) {
        formData.append(`loan_assets[${index}]`, value);
    }

    formData.append("date_of_payment", form.date_of_payment);
    formData.append("value", form.value);

    return formData
}


export default {
    namespaced: true,
    state: {
        loanItems: [],
        loans: [],
        meta: {},
        filters: {
            search: '',
            status: '',
        },
    },
    mutations: {
        setLoans(state, loans) {
            state.loans = loans;
        },
        setLoanItems(state, items) {
            state.loanItems = items;
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        getLoans({commit, state}, page = 1) {
            const query = queryBuilder(state.filters)
            axios
                .get(`/loans?page=${page}&${query}`)
                .then((res) => {
                    let response = res.data.data;
                    commit("setLoans", response.data);
                    commit("setMeta", response.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getUserLoans({commit}, form) {
            axios
                .get(`loan/user/${form.user_id}?page=${form.page}`)
                .then((res) => {
                    let response = res.data.data;
                    commit("setLoans", response.data);
                    commit("setMeta", response.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getLoanItems({commit, state}, form) {
            axios
                .get(`loan/items/user/${form.user_id}/order/${form.order_id}`)
                .then((res) => {
                    let items = res.data.data;
                    commit("setLoanItems", items);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        payLoan({commit}, form) {
            axios
                .post(`loan/pay/user/${form.user_id}/loan/${form.loan_id}?gateway=${form.gateway}`)
                .then((res) => {
                    const url = res.data.data.payment_url

                    if (url !== undefined) {
                        window.location.href = url;
                    } else {
                        toast('قسط قبلا پرداخت شده است', 'قسط قبلا پرداخت شده است')
                        store.dispatch('Loan/getLoanItems', form)
                    }

                })
                .catch((error) => {
                    store.dispatch('Loan/getLoanItems', form)
                    console.log(error);
                });
        },
        createLoan({commit}, form) {
            let formData = reshapeLoanForm(form)

            let req = axios
                .post(`loan/create/order/${form.order_id}`, formData)

            req.then((res) => {
                toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
            })
                .catch((error) => {
                    console.log(error);
                });
            return req
        },
        updateLoan({commit}, form) {

            let formData = reshapeLoanForm(form)
            let req = axios
                .post(`/loan/update/loan/${form.loan_id}`, formData)

            req.then((res) => {
                toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
            })
                .catch((error) => {
                    console.log(error);
                });
            return req
        },
        removeLoanAsset({commit}, form) {

            let req = axios.post(`loan/remove-asset/loan/${form.loan_id}`, form)


            req.then((res) => {
                toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
            })
                .catch((error) => {
                    console.log(error);
                });

            return req

        },
    },
    getters: {
        getLoans: (state) => state.loans,
        getLoanItems: (state) => state.loanItems,
        getPaginationMeta: (state) => state.meta,
    },
};
